import { checkIsHomologEnvironment } from './isHomologEnvironment'

export const isTestEnvironment = () => import.meta.env.NEXT_PUBLIC_TEST === 'true'
export const getLocalUserRoles = () =>
  import.meta.env.NEXT_PUBLIC_USER_ROLES_LOCAL?.split(',')?.map((role: string) => role.toLowerCase()) || []
export const getLocalBusinessUnit = () => import.meta.env.NEXT_PUBLIC_BUSINESS_UNIT_LOCAL
export const getMicrosoftLoginUrl = () => import.meta.env.NEXT_PUBLIC_URL_MICROSOFT
export const getGraphqlApi = () => import.meta.env.NEXT_PUBLIC_GRAPHQL_API
export const getS3BaseUrl = () =>
  import.meta.env.NEXT_PUBLIC_S3_BASE_URL || 'https://loyalty-jobs-hml.s3.us-east-1.amazonaws.com'
export const getEnvName = () => import.meta.env.NEXT_PUBLIC_ENV_NAME

export const isHomologEnvironment = (): boolean =>
  checkIsHomologEnvironment(globalThis.location?.hostname, getEnvName())
export const getAppVersion = () => import.meta.env.NEXT_PUBLIC_APP_VERSION
export const getPostalCodeApi = () => import.meta.env.NEXT_PUBLIC_POSTALCODE_API
export const getRegionClientId = () => import.meta.env.NEXT_PUBLIC_REGION_CLIENT_ID
export const getRegionClientSecret = () => import.meta.env.NEXT_PUBLIC_REGION_CLIENT_SECRET
export const isTestUsersEnabled = () => import.meta.env.NEXT_PUBLIC_TEST_USERS === 'true'
export const getTestTokenAdmin = () => import.meta.env.NEXT_PUBLIC_TOKEN_ADMIN
export const getTestTokenLgpd = () => import.meta.env.NEXT_PUBLIC_TOKEN_LGPD
export const getTestTokenAntiFraud = () => import.meta.env.NEXT_PUBLIC_TOKEN_ANTI_FRAUD
export const getTestTokenCrm = () => import.meta.env.NEXT_PUBLIC_TOKEN_CRM
export const getTestTokenService = () => import.meta.env.NEXT_PUBLIC_TOKEN_SERVICE
export const getBenefitIdExclusiveEvents = () => import.meta.env.NEXT_PUBLIC_BENEFIT_ID_EXCLUSIVE_EVENTS
export const getBenefitIdFactoryVisit = () => import.meta.env.NEXT_PUBLIC_BENEFIT_ID_FACTORY_VISIT
export const getTestTokenServiceFranchised = () => import.meta.env.NEXT_PUBLIC_TOKEN_SERVICE_FRANCHISED
export const getLedgerApi = () => import.meta.env.NEXT_PUBLIC_LEDGER_API || 'http://localhost:3004'

export const stripTrailingSlashes = (url: string): string => {
  let end = url.length
  while (end > 0 && url[end - 1] === '/') {
    end--
  }
  return url.slice(0, end)
}
